function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import styles from './AppPreview.module.scss';
import { Anchor, AspectRatio, Container, Image, Text, Title } from '@mantine/core';
import dashboardPreview from '@/assets/previews/Dashboard.png';
import commandsPreview from '@/assets/previews/Commands.png';
import songRequestPreview from '@/assets/previews/SongRequests.png';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { WebRoutes } from '@/utils/constants';
import { AnimatePresence, motion, useAnimation } from 'framer-motion';
import classNames from 'classnames';
var AppPreviewPanel = {
    DASHBOARD: 0,
    COMMANDS: 1,
    SONG_REQUESTS: 2
};
function PaginationBar(_param) {
    var isActive = _param.isActive, duration = _param.duration, isComplete = _param.isComplete, onComplete = _param.onComplete, panel = _param.panel, onHandleClick = _param.onHandleClick, props = _object_without_properties(_param, [
        "isActive",
        "duration",
        "isComplete",
        "onComplete",
        "panel",
        "onHandleClick"
    ]);
    var className = props.className, rest = _object_without_properties(props, [
        "className"
    ]);
    var controls = useAnimation();
    var handleClick = React.useCallback(function() {
        onHandleClick(panel);
    }, [
        onHandleClick,
        panel
    ]);
    useEffect(function() {
        var timeout = null;
        if (isActive) {
            controls.set({
                scaleX: 0
            });
            timeout = setTimeout(onComplete, duration * 1000);
            controls.start({
                scaleX: 1,
                transition: {
                    duration: duration,
                    ease: [
                        0.2,
                        0,
                        0.8,
                        1
                    ]
                }
            });
        } else {
            controls.set({
                scaleX: isComplete ? 1 : 0
            });
        }
        return function() {
            if (timeout != null) {
                clearTimeout(timeout);
                controls.stop();
            }
        };
    }, [
        isActive,
        controls,
        duration,
        onComplete,
        isComplete
    ]);
    return /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({
        className: classNames(styles.paginationDotContainer, className),
        whileHover: {
            scale: 1.2
        },
        whileTap: {
            scale: 0.9
        },
        onClick: handleClick
    }, rest), {
        children: /*#__PURE__*/ _jsx(motion.div, {
            animate: controls,
            className: styles.paginationDot
        })
    }));
}
export default function AppPreview(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    var _React_useState = _sliced_to_array(React.useState(AppPreviewPanel.DASHBOARD), 2), value = _React_useState[0], setValue = _React_useState[1];
    var intl = useIntl();
    var onComplete = React.useCallback(function() {
        setValue(function(prev) {
            return (prev + 1) % Object.keys(AppPreviewPanel).length;
        });
    }, []);
    var handleClick = React.useCallback(function(panel) {
        setValue(panel);
    }, []);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: classNames(styles.appPreview, className)
    }, props), {
        children: /*#__PURE__*/ _jsxs(Container, {
            size: "lg",
            children: [
                /*#__PURE__*/ _jsx(Title, {
                    className: styles.title,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "cGVjnI",
                        defaultMessage: "Built for Everyone"
                    })
                }),
                /*#__PURE__*/ _jsx(Text, {
                    size: "xl",
                    c: "dimmed",
                    className: styles.description,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "VOuQjg",
                        defaultMessage: "Made for everyone, no matter if you're just starting out or a seasoned streamer. <anchor>Learn More.</anchor>",
                        values: {
                            anchor: function(chunks) {
                                return /*#__PURE__*/ _jsx(Anchor, {
                                    component: Link,
                                    to: WebRoutes.DASHBOARD,
                                    children: chunks
                                });
                            }
                        }
                    })
                }),
                /*#__PURE__*/ _jsx(AspectRatio, {
                    ratio: 16 / 9,
                    className: styles.imageContainer,
                    children: /*#__PURE__*/ _jsx(AnimatePresence, {
                        mode: "popLayout",
                        initial: false,
                        children: /*#__PURE__*/ _jsxs(motion.div, {
                            transition: {
                                duration: 0.75,
                                ease: 'easeInOut'
                            },
                            initial: {
                                opacity: 0
                            },
                            animate: {
                                opacity: 1
                            },
                            exit: {
                                opacity: 0
                            },
                            className: styles.panelContainer,
                            children: [
                                /*#__PURE__*/ _jsx(Image, {
                                    rel: "preload",
                                    src: dashboardPreview,
                                    alt: intl.formatMessage({
                                        id: "AJ+YDy",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Dashboard Preview"
                                            }
                                        ]
                                    }),
                                    className: classNames(styles.image, _define_property({}, styles.hidden, value !== AppPreviewPanel.DASHBOARD))
                                }),
                                /*#__PURE__*/ _jsx(Image, {
                                    rel: "preload",
                                    src: commandsPreview,
                                    alt: intl.formatMessage({
                                        id: "8Rf7ob",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Commands Preview"
                                            }
                                        ]
                                    }),
                                    className: classNames(styles.image, _define_property({}, styles.hidden, value !== AppPreviewPanel.COMMANDS))
                                }),
                                /*#__PURE__*/ _jsx(Image, {
                                    rel: "preload",
                                    src: songRequestPreview,
                                    alt: intl.formatMessage({
                                        id: "sOryb9",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Song Requests Preview"
                                            }
                                        ]
                                    }),
                                    className: classNames(styles.image, _define_property({}, styles.hidden, value !== AppPreviewPanel.SONG_REQUESTS))
                                })
                            ]
                        }, value)
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.controls,
                    children: [
                        /*#__PURE__*/ _jsx(PaginationBar, {
                            panel: AppPreviewPanel.DASHBOARD,
                            onComplete: onComplete,
                            isComplete: value > AppPreviewPanel.DASHBOARD,
                            isActive: value === AppPreviewPanel.DASHBOARD,
                            onHandleClick: handleClick,
                            duration: 10
                        }),
                        /*#__PURE__*/ _jsx(PaginationBar, {
                            onComplete: onComplete,
                            panel: AppPreviewPanel.COMMANDS,
                            isActive: value === AppPreviewPanel.COMMANDS,
                            isComplete: value > AppPreviewPanel.COMMANDS,
                            onHandleClick: handleClick,
                            duration: 10
                        }),
                        /*#__PURE__*/ _jsx(PaginationBar, {
                            onComplete: onComplete,
                            panel: AppPreviewPanel.SONG_REQUESTS,
                            isActive: value === AppPreviewPanel.SONG_REQUESTS,
                            isComplete: value > AppPreviewPanel.SONG_REQUESTS,
                            onHandleClick: handleClick,
                            duration: 10
                        })
                    ]
                })
            ]
        })
    }));
}
